import { useEiiApi } from "../api/EiiApiClient";
import { EiiFrontendService } from "../services/EiiFrontendService";

export const useEiiService = (): EiiFrontendService =>
  new EiiFrontendService(useEiiApi());
